/* eslint-disable camelcase */
import React from 'react';
import { Field, Form } from 'formik';
import { Button, Col, Row } from 'reactstrap';
import LoadingButton from 'components/common/LoadingButton';
import FormikInputField from 'components/Fields/FormikInputField';
import CardWithTitle from 'components/CardWithTitle';
import ReactSelect from 'components/Fields/ReactSelect';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import { FAQ_TYPES } from 'pages/ApplicationUI/constant';

const AddEditFAQForm = (props) => {
  const { handleSubmit, isSubmitting, isValid, dirty, toggleFAQForm, type } =
    props;

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle>
        <Row>
          <Col sm={12} className="mt-3">
            <Field
              label="FAQ Category"
              name="faqCategory"
              type="select"
              component={ReactSelect}
              data={[
                { id: FAQ_TYPES.INDIAN_FAQ, label: 'INDIAN' },
                { id: FAQ_TYPES.FOREIGN_FAQ, label: 'FOREIGN' },
              ]}
              keys={{ id: 'id', label: 'label' }}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.label}
              // isDisabled
              required
            />
          </Col>
          <Col sm={12} className="mt-3">
            <Field
              label="Question"
              name="question"
              type="text"
              component={FormikInputField}
              placeholder="Enter Question"
              required
            />
          </Col>

          <Col sm={12} className="mt-3">
            <Field
              label="Answer"
              name="answer"
              type="textarea"
              className="msg-field"
              component={FormikInputField}
              placeholder="Enter Answer"
              required
            />
          </Col>
        </Row>
      </CardWithTitle>
      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={toggleFAQForm}
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting}
          color="primary"
          size="sm"
          type="submit"
        >
          {type === ADD_EDIT_CONSTANT.EDIT ? 'Update' : 'Create'}
        </LoadingButton>
      </div>
    </Form>
  );
};

export default AddEditFAQForm;
